import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { QuestionnaireQuestion, QMenuOption, QQChild } from '../../shared/models/questionnaire-question';

import { StringHelpers } from '../../shared/helpers/string-helpers';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { faCheck } from '../../icons';
@Component({
    selector: 'app-question',
    templateUrl: './question.component.html',
    styleUrls: ['./question.component.scss'],
    animations: [
        // the fade-in/fade-out animation.
        trigger('fadeInOut', [
            // the "in" style determines the "resting" state of the element when it is visible.
            state('in', style({ opacity: 1 })),
            // fade in when created. this could also be written as transition('void => *')
            transition(':enter', [
                style({ opacity: 0 }),
                animate('0.5s ease-in-out')
            ]),
            // fade out when destroyed. this could also be written as transition('void => *')
            transition(':leave', animate('0.5s ease-in-out', style({ opacity: 0 })))
        ])
    ],
    standalone: false
})
export class QuestionComponent implements OnInit {
	  faCheck = faCheck;
	@Input() question: QuestionnaireQuestion;
	@Output() onAnswer: EventEmitter<QuestionnaireQuestion> = new EventEmitter();

  currentlySelected: number = 0;
  answerArr: string[] = [];
  letters: string[];

  constructor() { }

  ngOnInit() {
  	QuestionnaireQuestion.init(this.question);
    // if 'menu' or 'multimenu', generate letters array.
    if(this.question.type_s.indexOf('menu') > -1) {
      this.letters = StringHelpers.genCharArray('A','Z');
    }
  }

  answer(answer: string) {
    if(answer == null) {
      answer = '';
    }

  	this.question.answer = answer;
    setTimeout(() => {
      this.onAnswer.emit(this.question);
    }, 100);
  }
  answerMulti(result: any[]) {
    this.answer(this.question.toStringFunc(result));
  }

  addToAnswerArr(option: QMenuOption) {
    if(this.currentlySelected == this.question.maxSelectedItems)
      return;

    option.selected = true;
    this.currentlySelected++;
    this.answerArr.push(option.value);
  }
  removeFromAnswerArr(option: QMenuOption) {
    option.selected = false;
    this.currentlySelected--;
    let idx = this.answerArr.indexOf(option.value);

    this.answerArr.splice(idx, 1);
  }
  toggleOptionAnswerArr(option: QMenuOption) {
    let idx = this.answerArr.indexOf(option.value);

    if(idx === -1) {
      this.addToAnswerArr(option);
    } else {
      this.removeFromAnswerArr(option);
    }
  }

  onMultiSelectChange(selectedItems: QMenuOption[]) {
    this.currentlySelected = selectedItems.length;
  }
}
